import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icons/Shower.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/images/Royal.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/rooms/Hero.tsx");
